/*
  "/" is served as pre-rendered HTML (scripts/prerender.mjs) inside #prerendered, so the page is
  readable before any JavaScript runs. The app renders into the hidden #root, and the
  pre-rendered copy is removed once the app shows the same page (or navigates elsewhere).
*/

export function startPrerenderHandoff(subscribe: (onPath: (pathname: string) => void) => void): void {
  if (!document.getElementById('prerendered')) return;
  document.documentElement.dataset.prerendered = '';
  subscribe((pathname) => {
    if (pathname !== '/') revealApp();
  });
  // Never leave the app hidden, whatever happens.
  window.setTimeout(revealApp, 10_000);
}

export function revealApp(): void {
  document.getElementById('prerendered')?.remove();
  delete document.documentElement.dataset.prerendered;
}
